export function getPortalRoot(): HTMLElement {
  if (typeof document === 'undefined') {
    return document.body as HTMLElement;
  }

  let portalRoot = document.getElementById('wanzo-portal-root');
  if (!portalRoot) {
    portalRoot = document.createElement('div');
    portalRoot.id = 'wanzo-portal-root';
    portalRoot.setAttribute('aria-hidden', 'true');
    document.body.appendChild(portalRoot);
  }

  return portalRoot as HTMLElement;
}
